import { Loading } from 'element-ui';
let loadingInstance = null;
let loadNum = 0;
let pluginNum = 0;
let listModuleUrl = window.config.host + '/menuManager/listModuleFullPath';
let pluginIds = decodeURIComponent((new RegExp('[?|&]' + 'pluginIds' + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null;
pluginIds = pluginIds == null ? [] : pluginIds.split(',');
let contentType = 'application/json';
if (window.config.active && window.config.active === 'dev') {
    listModuleUrl = 'http://127.0.0.1:3000/listModuleFullPath';
    contentType = 'text/plain';
}
window.$.ajax({
    type: 'post',
    async: false,
    url: listModuleUrl,
    dataType: 'json',
    contentType: contentType,
    data: JSON.stringify(pluginIds),
    success: function(response) {
        console.info(response.content);
        if (response.content) {
            if (response.content !== null && response.content !== undefined) {
                let moduleList = response.content;
                pluginNum = moduleList.length;
                if (Array.isArray(moduleList) && moduleList.length > 0) {
                    loadingInstance = Loading.service({ fullscreen: true, text: '' });
                    let fullcalendarCss = [];
                    for (let plugin of moduleList) {
                        let jsList = [];
                        let indexJsList = [];
                        let cssList = [];
                        let indexcssList = [];
                        let chunkcssList = [];
                        for (const item of plugin) {
                            if (item.toString().endsWith('.js') || item.toString().endsWith('.JS')) {
                                let pos = item.lastIndexOf('/'); //'/所在的最后位置'
                                let name = item.substr(pos + 1);
                                if (name === 'index.js') {
                                    indexJsList.push(item.toString());
                                } else {
                                    jsList.push(item.toString());
                                }
                            } else if (item.toString().endsWith('.css') || item.toString().endsWith('.CSS')) {
                                let pos = item.lastIndexOf('/'); //'/所在的最后位置'
                                let name = item.substr(pos + 1);
                                if (name === 'index.css') {
                                    indexcssList.push(item.toString());
                                } else if (name === 'chunk-vendors.css') {
                                    chunkcssList.push(item.toString());
                                } else if (item.indexOf('@fullcalendar/core/main') != -1) {
                                    fullcalendarCss.push(item);
                                } else {
                                    cssList.push(item.toString());
                                }
                            }
                        }
                        if (fullcalendarCss.length > 0) {
                            chunkcssList.push(...fullcalendarCss);
                            fullcalendarCss = [];
                        }
                        cssList.push(...indexcssList);
                        chunkcssList.push(...cssList);
                        jsList.push(...indexJsList);
                        for (const cssItem of chunkcssList) {
                            creatCss(cssItem.toString());
                        }
                        if (jsList.length > 0) {
                            creatScript(jsList);
                        } else {
                            loadNum++;
                            if (loadNum == pluginNum) {
                                loadingInstance.close();
                                //触发插件加载完成后事件
                                window.vue.$EventBus.$emit('pluginLoadEnd');
                            }
                        }
                    }
                }
            }
        }
    }
});
function creatScript(jsLink) {
    let index = 0;
    let load = function(js) {
        index++;
        let script = document.createElement('script');
        script.src = js;
        script.onload = function() {
            if (index < jsLink.length) {
                load(jsLink[index]);
            } else {
                loadNum++;
                if (loadNum == pluginNum) {
                    loadingInstance.close();
                    //触发插件加载完成后事件
                    window.vue.$EventBus.$emit('pluginLoadEnd');
                }
            }
        };
        script.onerror = function() {
            if (index < jsLink.length) {
                load(jsLink[index]);
            } else {
                loadNum++;
                if (loadNum == pluginNum) {
                    loadingInstance.close();
                    //触发插件加载完成后事件
                    window.vue.$EventBus.$emit('pluginLoadEnd');
                }
            }
        };
        document.body.appendChild(script);
    };
    load(jsLink[index]);
}
function creatCss(cssLink) {
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssLink;
    document.getElementsByTagName('head')[0].appendChild(link);
}
